/**
 * 系统管理  角色管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-bottom: 20px;">
      <el-breadcrumb-item :to="{ path: '/base/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>角色管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="float: left;">
      <el-table ref="roleTable" v-loading="gloading" :data="roletable" border highlight-current-row @current-change="handleCurrentChange" style="width: 180px;">
        <el-table-column prop="gname" label="角 色" width="179" align="center">
        </el-table-column>
      </el-table>
      <div id="role_bar">
        <i class="el-icon-plus" @click="addrolewin()"></i>
        <i class="el-icon-edit" @click="editrolewin()"></i>
        <i class="el-icon-delete" @click="deleterole()"></i>
      </div>
    </div>
    <div style="float: left;margin-left: 30px;width: 460px;">
      <el-button type="primary" size="mini" style="margin-bottom: 10px;" @click="transferVisible"><i class="el-icon-plus"></i> 用 户</el-button>
      <el-table :data="usertable" v-loading="uloading" border>
        <el-table-column type="index" width="60" align="center">
        </el-table-column>
        <el-table-column prop="uname" label="用户" width="200" align="center">
        </el-table-column>
        <el-table-column prop="realname" label="姓名" align="center">
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>
    <!-- 添加角色 -->
    <el-dialog :title="title" width="630px" :visible.sync="roleVisible">
      <el-input v-model="gform.gname"></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addrolebar" size="mini">添 加</el-button>
      </div>
    </el-dialog>
    <!-- 添加用户 -->
    <transfer ref="childs" @callback="callback"></transfer>
  </div>
</template>

<script>
  import Pagination from '../../components/Pagination'
  import transfer from '../../components/transfer'
  import { addRole,delRole,roleList,getUsers,roleUsers,setGroups } from '../../api/baseset'
  export default {
    data() {
      return {
        gloading: false,
        uloading: false,
        roleVisible: false,
        gform: {
          gname: ''
        },
        title: '添加角色',
        roletable: [],
        usertable: [],
        transerdata: [],
        currentRow: [],
        formInline: {
          page: 1,
          limit: 10
        },
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        }
      }
    },
    components:{
      transfer,Pagination
    },
    created() {
      this.getroleData()
    },
    methods: {
      getroleData() {
        this.gloading = true
        roleList().then(res => {
          this.gloading = false
          this.roletable = res.data
          this.setCurrent(this.roletable[0])
          this.getRoleUsers(this.roletable[0].id);
        })
      },
      getRoleUsers(gid) {
        this.uloading = true
        this.formInline.gid = gid;
        roleUsers(this.formInline).then(res => {
          this.uloading = false
          this.usertable = res.data
          // 分页赋值
          this.pageparm.currentPage = this.formInline.page
          this.pageparm.pageSize = this.formInline.limit
          this.pageparm.total = res.count
        })
      },
      setCurrent(row) {
        this.$refs.roleTable.setCurrentRow(row);
      },
      handleCurrentChange(val) {
        this.currentRow = val;
        this.getRoleUsers(val.id);
      },
      addrolewin() {
        this.roleVisible = true
      },
      editrolewin() {
        this.title = '编辑角色'
        this.gform = this.currentRow
        this.roleVisible = true
      },
      deleterole() {
        this.$confirm('您确定要删除【'+this.currentRow.gname+'】吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const data = {id:this.currentRow.id}
          delRole(data).then(res => {
            if(res.code == 0){
              this.getroleData()
              this.$message({
                type: 'success',
                message: res.msg
              })
            }else{
              this.$message.error(res.msg)
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      addrolebar() {
        this.gloading = true;
        addRole(this.gform).then(res => {
          this.gloading = false
          if(res.code == 0){
            this.roleVisible = false
            this.getroleData()
            this.$message({
              type: 'success',
              message: res.msg
            })
          }else{
            this.$message.error(res.msg);
          }
        }).catch(err => {
          this.gloading = false
          this.$message.error('数据加载失败');
        })
      },
      transferVisible() {
        this.$refs.childs.transferVisible = true
        const data = {gid:this.currentRow.id}
        getUsers(data).then(res => {
          this.$refs.childs.data =res.data.list;
          this.$refs.childs.value =res.data.value;
        })
      },
      callback(val) {
        const data = {gid:this.currentRow.id,users:val}
        setGroups(data).then(res => {
          this.getRoleUsers(this.currentRow.id);
          if(res.code == 0){
            this.$message({
              type: 'success',
              message: res.msg
            })
          }else{
            this.$message.error(res.msg);
          }
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      }
    }
  }
</script>

<style>
.el-dialog__body{padding: 0px 20px 20px;}
#role_bar{margin-top: 10px;}
#role_bar i{margin-left: 30px;}
</style>



// WEBPACK FOOTER //
// src/views/system/Role.vue